import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import Style from "../addStore.module.scss";
import useGateDelivery from "./useGateDelivery";
const GateDelivery = ({ formik, getFieldError, checkError, isStoreCreate }) => {
  const {
    isEdit,
    handleCloseModal,
    handleTimeChange,
    daysOfWeek,
    handleToggle,
    getTimeValue,
    getStatus,
    // getMinToTime,
    // curbTimeError,
  } = useGateDelivery(formik);

  return (
    <>
      <div className="form-check form-switch pro-mb-4">
        <input
          className="form-check-input cursor-pointer"
          type="checkbox"
          role="switch"
          id="gate_delivery"
          name="gate_delivery"
          checked={Boolean(formik.values?.gate_delivery === 1) ?? false}
          onChange={(e) => {
            formik.setFieldValue("gate_delivery", e.target.checked ? 1 : 2);
          }}
        />
        <label htmlFor="gate_delivery" className="pro-check-label">
          Set Gate Delivery Hours
        </label>
        {getFieldError("gate_delivery") && (
          <div className={`${Style.form_toggle_err_msg}`}>Please select at least one day's hours.</div>
        )}
      </div>

      {/* {formik.values?.gate_delivery === 1 && ( */}
        <>
          {daysOfWeek.map((day) => (
            <div
              key={day}
              className={`pro-d-flex pro-flex-column pro-mb-4 ${Style.time_wrap}`}
            >
              <label className="pro-font-sm pro-mb-1 pro-fw-medium">
                {day}
              </label>
              <div
                className={`pro-d-flex pro-items-center ${Style.time_picker_wrap}`}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={getTimeValue(day, "from") || ""}
                    onChange={(newValue) =>
                      handleTimeChange(day, "from", newValue)
                    }
                    className="time-picker"
                    slotProps={{
                      actionBar: {
                        actions: ["clear", "accept"],
                        sx: {
                          "& .MuiButton-root:first-of-type": {
                            background: "none !important",
                            border: "none",
                            boxShadow: "none",
                            textTransform: "capitalize",
                            color: "var(--pro-primary) !important",
                            fontSize: "14px",
                            fontWeight: 600,
                            "&:hover": {
                              background: "none !important",
                              color: "var(--pro-primary-hover) !important",
                            },
                          },
                        },
                      },
                    }}
                    disabled={
                      getStatus(day)?.toString() === "2" ||
                      formik.values.gate_delivery?.toString() === "2"
                    }
                  />

                  <span className="pro-px-3 pro-d-flex pro-items-center">
                    <span className="material-symbols-outlined x4">
                      {" "}
                      remove{" "}
                    </span>
                  </span>

                  <TimePicker
                    value={getTimeValue(day, "to") || ""}
                    onChange={(newValue) =>
                      handleTimeChange(day, "to", newValue)
                    }
                    className="time-picker"
                    // minTime={getMinToTime(day)}
                     slotProps={{
                      actionBar: {
                        actions: ["clear", "accept"],
                        sx: {
                          "& .MuiButton-root:first-of-type": {
                            background: "none !important",
                            border: "none",
                            boxShadow: "none",
                            textTransform: "capitalize",
                            color: "var(--pro-primary) !important",
                            fontSize: "14px",
                            fontWeight: 600,
                            "&:hover": {
                              background: "none !important",
                              color: "var(--pro-primary-hover) !important",
                            },
                          },
                        },
                      },
                    }}
                    disabled={
                      getStatus(day)?.toString() === "2" ||
                      formik.values.gate_delivery?.toString() === "2"
                    }
                  />
                  <div className="form-check form-switch pro-mb-0 pro-ms-auto">
                    <input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id={`${day}-switch`}
                      checked={getStatus(day)?.toString() === "1" || false}
                      onChange={(e) => handleToggle(day, e.target.checked)}
                      disabled={formik.values.gate_delivery?.toString() === "2"}
                    />
                  </div>
                </LocalizationProvider>
              </div>
            </div>
          ))}

          <div>
            <Input
              label={"Gate Delivery Note"}
              type="text"
              id="gate_delivery_note"
              name="gate_delivery_note"
              className={`pro-input lg ${
                getFieldError("gate_delivery_note") && " error"
              }`}
              {...formik.getFieldProps("gate_delivery_note")}
              error={getFieldError("gate_delivery_note")}
              errorMessage={getFieldError("gate_delivery_note")}
              disabled={formik.values.gate_delivery?.toString() === "2"}
            />
          </div>
          <div className="pro-rtl">
            <Input
              label={"(مذكرة تسليم البوابة) Gate Delivery Note"}
              type="text"
              id="alias_gate_delivery_note"
              name="alias_gate_delivery_note"
              className={`pro-input lg ${
                getFieldError("alias_gate_delivery_note") && " error"
              }`}
              {...formik.getFieldProps("alias_gate_delivery_note")}
              error={getFieldError("alias_gate_delivery_note")}
              errorMessage={getFieldError("alias_gate_delivery_note")}
              disabled={formik.values.gate_delivery?.toString() === "2"}
            />
          </div>

          <div>
            <Input
              label={"Gate Delivery Info"}
              type="text"
              id="gate_delivery_info"
              name="gate_delivery_info"
              className={`pro-input lg ${
                getFieldError("gate_delivery_info") && " error"
              }`}
              {...formik.getFieldProps("gate_delivery_info")}
              error={getFieldError("gate_delivery_info")}
              errorMessage={getFieldError("gate_delivery_info")}
              disabled={formik.values.gate_delivery?.toString() === "2"}
            />
          </div>
          <div className="pro-rtl">
            <Input
              label={"(معلومات تسليم البوابة) Gate Delivery Info"}
              type="text"
              id="alias_gate_delivery_info"
              name="alias_gate_delivery_info"
              className={`pro-input lg ${
                getFieldError("alias_gate_delivery_info") && " error"
              }`}
              {...formik.getFieldProps("alias_gate_delivery_info")}
              error={getFieldError("alias_gate_delivery_info")}
              errorMessage={getFieldError("alias_gate_delivery_info")}
              disabled={formik.values.gate_delivery?.toString() === "2"}
            />
          </div>
        </>
      {/* )} */}
      <div className={`col-12 pro-d-flex pro-justify-end pro-pb-5 pro-mt-auto`}>
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleCloseModal}
          type="button"
        >
          Cancel
        </Button>

        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="submit"
          onClick={checkError}
          disabled={isStoreCreate}
        >
          {isEdit && !isStoreCreate
            ? "Update"
            : isStoreCreate && isEdit
            ? "Updating..."
            : isStoreCreate && !isEdit
            ? "Creating..."
            : "Create"}
        </Button>
      </div>
    </>
  );
};

export default GateDelivery;
